import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import Guide from './modules/Guide/Guide.js'
import user from './modules/user'


const store = new Vuex.Store({
  modules: {
    Guide,
    user
  },
  strict: process.env.NODE_ENV !== 'production'
})

export default store
